
import { createAction, createReducer, on, props } from '@ngrx/store';
import { OpenedTaskInfo } from '../api/OpenedTaskInfo';
import * as lodash from 'lodash';
import { TaskDTO } from '../api/plyca-dtos';

export const DELETE_OPENEDTASKS = createAction('DELETE_OPENEDTASKS', props<{ avoidPersistence?: boolean }>());
export const ADD_OPENEDTASK = createAction('ADD_OPENEDTASK', props<{ task: OpenedTaskInfo, avoidPersistence?: boolean }>());
export const DELETE_OPENEDTASK = createAction('DELETE_OPENEDTASK', props<{ task: OpenedTaskInfo, avoidPersistence?: boolean }>());
export const GET_OPENEDTASK = createAction('GET_OPENEDTASK');
export const SET_OPENEDTASKS_TYPE = 'SET_OPENEDTASKS';
export const SET_OPENEDTASKS = createAction(SET_OPENEDTASKS_TYPE, props<{ tasks: OpenedTaskInfo[], avoidPersistence?: boolean }>());

const initialState = new Array<OpenedTaskInfo>();

const _openedTasksReducer = createReducer(
  initialState,
  on(DELETE_OPENEDTASKS, () => initialState),
  on(ADD_OPENEDTASK, (state, { task }) => {
    let index = state.filter(item => {
      let openedTask: boolean = item.taskId === task.taskId;
      let openedFE: boolean = item.id === task.id;

      return openedTask && openedFE;
    }).length;

    if (index > 0) {
      return state;
    } else {
      let clonedTask = lodash.cloneDeep(task) as OpenedTaskInfo;
      clonedTask.taskDTO.work = undefined;
      return [...state, clonedTask];
    }
  }),
  on(GET_OPENEDTASK, (state) => state),
  on(DELETE_OPENEDTASK, (state, { task }) => state.filter(item => {
    return item.taskId !== task.taskId;
  })),
  on(SET_OPENEDTASKS, (state, { tasks }) => tasks)
);

export function openedTasksReducer(state, action) {
  return _openedTasksReducer(state, action);
}
